@if (href()) {
    <a class="ms-active-highlight" [msAutomation]="attribute() ?? ''" [href]="href() ?? ''" [vnSpeculativeLink]="href() ?? ''" (click)="clicked()">
        <ng-container *ngTemplateOutlet="itemTemplate" />
    </a>
} @else {
    <a class="ms-active-highlight" tabindex="0" [msAutomation]="attribute() || ''" (click)="clicked()" (keydown)="clicked()">
        <ng-container *ngTemplateOutlet="itemTemplate" />
    </a>
}

<ng-template #itemTemplate>
    <div class="icon">
        @if (icon()) {
            <vn-icon class="base-icon {{ isCountryFlag ? 'country-icon' : '' }}" [name]="icon()!" [size]="isEpcotEnabled ? '24' : '16'" />
        }
        <ng-content select="[item-icon]" />
    </div>
    <div class="title">
        @if (title()) {
            <span>{{ title() }}</span>
        }
        <ng-content select="[item-title]" />
        <ng-content select="ms-promotion-badge" />
    </div>
    @if (count()) {
        <div class="count">{{ count() }}</div>
    }
    @if (arrow()) {
        <div class="arrow">
            <vn-icon name="theme-right" size="16" />
        </div>
    }
    <ng-content select="[esports-header-content]" />
</ng-template>
